module.exports = __webpack_public_path__ + "static/media/Achilles.135fa700.png";